import { useEffect, useState } from 'react';

type Viewport = 'sm' | 'md' | 'lg';

const getViewport = () => {
  let viewport: Viewport = 'sm';
  if (window.innerWidth >= 1024) {
    viewport = 'lg';
  } else if (window.innerWidth >= 768) {
    viewport = 'md';
  }
  return viewport;
};

export default function useViewport(callback?: (viewport: Viewport) => void) {
  const [viewport, setViewport] = useState<Viewport>(getViewport());

  useEffect(() => {
    const onResize = () => {
      const newViewport = getViewport();
      callback?.(newViewport);
      setViewport(newViewport);
    };
    onResize();
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return viewport;
}
